import { render, staticRenderFns } from "./DistribuzioneClienti.vue?vue&type=template&id=67b9acc6"
import script from "./DistribuzioneClienti.vue?vue&type=script&lang=js"
export * from "./DistribuzioneClienti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports